<template>
  <div
    v-if="show"
    id="snackbar"
    :class="['sb-container', snackbar.status === 'error' ? 'error-container' : '']"
    :style="{ backgroundColor: snackbar.bgColor, color: snackbar.fontColor }"
  >
    <div class="grid-column ai-c jc-s">
      <div class="sac__font-16 bold">{{ snackbar.header }}&nbsp;</div>
      <div class="sac__font-16">
        {{ snackbar.message }}
      </div>
      <button
        v-if="snackbar.action"
        type="button"
        class="sac__font-16 semi-bold underline margin-left-4"
        @click="handleAction"
      >
        {{ snackbar.action.name }}
      </button>
    </div>
    <button type="button" class="img-size-20" @click="closeToast">
      <img v-if="isDefault" src="@shared/assets/img/general/svg/x-black.svg" alt="x" />
      <img v-else src="@shared/assets/img/general/svg/x-white.svg" alt="x" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'SACSnackBar',
  data() {
    return {
      hideTimer: null,
    };
  },
  computed: {
    snackbar() {
      return this.$store.state.snackbar;
    },
    isDefault() {
      return this.$store.state.snackbar.contentColor === 'default';
    },
    show() {
      return this.$store.state.snackbar.show;
    },
    timer() {
      return this.$store.state.snackbar.timer * 1000;
    },
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.setHideTimer();
      } else {
        this.clearHideTimer();
      }
    },
  },
  mounted() {
    if (this.show) {
      this.setHideTimer();
    }
  },
  methods: {
    closeToast() {
      this.$store.dispatch('changeSnackbarValues', [
        {
          field: 'show',
          value: false,
        },
      ]);
    },
    handleAction() {
      if (this.snackbar.action && typeof this.snackbar.action.handler === 'function') {
        this.snackbar.action.handler();
        this.closeToast();
      }
    },
    clearHideTimer() {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
    },
    setHideTimer() {
      this.clearHideTimer();

      this.hideTimer = setTimeout(() => {
        this.closeToast();
      }, this.timer);
    },
  },
};
</script>

<style lang="scss">
#snackbar {
  height: 38px;
  background-color: $NBLUE100;
  display: flex;
  align-items: center;
  grid-auto-flow: column;
  justify-content: space-between;
  padding: 0 24px;
  transition: all 250ms ease-in-out;
  color: $WHITE;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  &.error-container {
    background-color: $TOMATO100;
  }
}
</style>
